export class InstallationListController {
    /* @ngInject */
    constructor(installationUsers, flowService, flowStateService) {
        this.installationUsers = installationUsers;
        this.flowService = flowService;
        this.installationUsersToDisplay = this.installationUsers;
        this.flowStateService = flowStateService;
    }

    chooseInstallationUser(installationUserId) {
        this.flowStateService.setInstallationUserId(installationUserId);
        this.flowService.nextFlow();
    }

    filterInstallationUsers(filter) {
        this.installationUsersToDisplay = [];
        this.installationUsers.forEach(installationUser => {
                if (installationUser.installation.displayName.toLowerCase().includes(filter.toLowerCase())) {
                    this.installationUsersToDisplay.push(installationUser);
                }
            }
        );
    }
}
